import { render, staticRenderFns } from "./ListaArticoliMov.vue?vue&type=template&id=45bc1108"
import script from "./ListaArticoliMov.vue?vue&type=script&lang=js"
export * from "./ListaArticoliMov.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports